import { Avatar } from "components/Avatar/index";
import styled, { css } from "styled-components";

export const ListItemContainer = styled.div`
  width: 100%;
`;

export const BoxWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  cursor: ${({ eligible }) => (eligible ? "pointer" : "not-allowed")};
  justify-content: space-between;
  padding: 0px 21px;
  width: 100%;
  height: 54px;
  background: ${({ theme }) => theme.card.bg.secondary};
  border-radius: 25px;
  border: 1px solid ${({ theme }) => theme.card.border.quaternary};
  overflow: hidden;
  ${({ showDivider, theme }) =>
    showDivider &&
    css`
      border: none;
      border-bottom: 1px solid ${theme.card.border.quaternary};
      border-radius: 0;
      margin-bottom: 10px;
    `}
`;

export const BrokerDetails = styled.div`
  display: flex;
`;

export const PortfolioWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  padding: 10px 20px 10px 0px;
`;

export const BrokerTitle = styled.div`
  color: ${({ theme }) => theme.card.font.tertiary};
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
`;

export const BrokerType = styled.div`
  color: ${({ theme }) => theme.card.font.quaternary};
  font-size: 12px;
  line-height: normal;
  opacity: 0.6;
`;

export const BrokerUrl = styled.p`
  margin: 4px 0;
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.card.font.secondary};
`;

export const BrokerImg = styled(Avatar)`
  width: 35px;
  height: 35px;
  img {
    width: 35px;
    height: 35px;
  }
`;

export const BrokerName = styled.div`
  font-weight: 500;
  font-size: 14px;
  max-width: 160px;
  span {
    opacity: 0.6;
  }
`;

export const NameWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
`;

export const EligibleMessage = styled.div`
  font-size: 12px;
  max-width: 305px;
`;

export const Name = styled.div`
  font-weight: 400;
  font-size: 16px;
  text-align: center;
  color: ${({ theme }) => theme.global.color.bodyColor};
`;
